import { render, staticRenderFns } from "./menuFaturamento.vue?vue&type=template&id=5872eac2"
import script from "./menuFaturamento.vue?vue&type=script&lang=js"
export * from "./menuFaturamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports